import { cx } from "@/utils";
import Typography from "@components/Typography";
import * as Dialog from "@radix-ui/react-dialog";

import styles from "../Modal.module.css";

export type ModalDescriptionProps = {
  children: React.ReactNode;
  className?: string;
};

const ModalTitle: React.FunctionComponent<ModalDescriptionProps> = ({
  children,
  className,
  ...rest
}) => {
  return (
    <Dialog.Description asChild>
      <Typography
        className={cx(styles.description, className)}
        variant="caption"
        {...rest}
      >
        {children}
      </Typography>
    </Dialog.Description>
  );
};

export default ModalTitle;
